import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NavigationProvider } from '@nrwl/navigation-abstract';

import {
  IComponentStateHistory,
  IValueChangedEvent,
  IWizardContentComponent
} from '../../../wizard.content';
import { LicensesPageService, TestTypeValue, UserService } from '@nrwl/common-lib';
import { TemplateService } from '@nrwl/test-setup';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TemplateTabsComponent } from '@nrwl/template-management';
import { TestLicense } from '@nrwl/licenses';

enum SIDEBAR_TEST {
  truespeedsTest = 'truespeed_test',
  serviceTest = 'service_test',
  multiStepTest = 'multistep_test',
  voipTest = 'voip_test',
  networkTest = 'network_test',
  twampTest = 'twamp_test',
  twampReflectorTest = 'twamp_reflector_test',
  y1564Test = 'y1564_test',
  y1731Test = 'y1731_test',
  rfc2544Test = 'rfc2544_test',
  udpTest = 'udp_test',
  httpTest = 'http_test',
  ftpTest = 'ftp_test',
  bertTest = 'bert_test'
}

@Component({
  selector: 'active-test-types-html',
  templateUrl: './active.test.types.template.html',
  providers: [],
  styleUrls: ['../active.test.wizard.style.scss']
})
export class ActiveTestTypesComponent implements IWizardContentComponent, OnInit {
  @Input() step: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() subStep: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() wizardCtrl: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() componentId: string;
  @Input() stateHistory?: IComponentStateHistory;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onDataValueChange = new EventEmitter<IValueChangedEvent>();
  @ViewChild('currentForm', { static: true }) form: NgForm;
  templateDialogRef: MatDialogRef<TemplateTabsComponent>;

  isActWebEnabled = false;

  allActiveTests = [
    {
      id: 'bert_test',
      description: 'Assess the reliability and performance of digital communication systems',
      iconUrl: 'images/bert.svg',
      name: 'L2 / L3 BERT',
      iconType: 'image',
      type: TestTypeValue.BERT,
      isLicenseActive: false
    },
    {
      id: 'y1564_test',
      description: 'Industry standard test methodology for Ethernet service activation',
      iconUrl: 'images/y1564.svg',
      name: 'Y.1564',
      iconType: 'image',
      type: TestTypeValue.Y1564,
      licenseInfo: TestLicense.Y1564,
      isLicenseActive: false
    },
    {
      id: 'rfc2544_test',
      description: 'Methodology for measuring performance of network devices and services',
      iconUrl: 'images/rfc2544.svg',
      name: 'RFC2544',
      iconType: 'image',
      type: TestTypeValue.RFC2544,
      licenseInfo: TestLicense.RFC2544,
      isLicenseActive: false
    },
    {
      id: 'truespeed_test',
      description: 'Test throughput performance using the RFC 6349 standard',
      iconUrl: 'images/truespeed.svg',
      name: 'TrueSpeed',
      iconType: 'image',
      type: TestTypeValue.TRUESPEED,
      licenseInfo: TestLicense.TRUESPEED,
      isLicenseActive: false
    },
    {
      id: 'udp_test',
      description: 'Test throughput performance for UDP connections',
      iconUrl: 'images/UDP.svg',
      name: 'UDP',
      iconType: 'image',
      type: TestTypeValue.UDP,
      licenseInfo: TestLicense.UDP,
      isLicenseActive: false
    },
    {
      id: 'http_test',
      description: 'Test download performance of HTTP connections',
      iconUrl: 'images/http.svg',
      name: 'HTTP',
      iconType: 'image',
      type: TestTypeValue.HTTP,
      licenseInfo: TestLicense.HTTP,
      isLicenseActive: false
    },
    {
      id: 'ftp_test',
      description: 'Test download performance of FTP connections',
      iconUrl: 'images/ftp.svg',
      name: 'FTP',
      iconType: 'image',
      type: TestTypeValue.FTP,
      licenseInfo: TestLicense.HTTP,
      isLicenseActive: false
    },
    {
      id: 'service_test',
      description: 'Monitor the performance of a defined application',
      iconUrl: 'images/services.svg',
      name: 'Service',
      iconType: 'image',
      type: TestTypeValue.SERVICE_CONTINUITY,
      licenseInfo: TestLicense.SERVICE_CONTINUITY,
      isLicenseActive: false
    },
    {
      id: 'voip_test',
      description: 'Monitor voice call quality between two sites',
      iconUrl: 'images/voip.svg',
      name: 'VoIP',
      iconType: 'image',
      type: TestTypeValue.VOIP,
      licenseInfo: TestLicense.VOIP,
      isLicenseActive: false
    },
    {
      id: 'multistep_test',
      description: 'Monitor web performance metrics of a defined application',
      iconUrl: 'images/multi-step.svg',
      name: 'Web Transactions',
      iconType: 'image',
      type: TestTypeValue.MULTISTEP,
      licenseInfo: TestLicense.MULTISTEP,
      isLicenseActive: false
    },
    // {
    //   id: 'network_test',
    //   description: 'Monitor network connections between two sites',
    //   iconUrl: 'images/network.svg',
    //   name: 'Network',
    //   iconType: 'image'
    // },
    {
      id: 'y1731_test',
      description: 'Industry standard test methodology for Ethernet service activation',
      iconUrl: 'images/y1564.svg',
      name: 'Y.1731',
      iconType: 'image',
      type: TestTypeValue.Y1731,
      isLicenseActive: true
    },
    {
      id: 'twamp_test',
      description: 'Monitor network connections between two endpoints',
      iconUrl: 'images/twamp.svg',
      name: 'Twamp Initiator',
      iconType: 'image',
      type: TestTypeValue.TWAMP,
      isLicenseActive: true
    },
    {
      id: 'twamp_reflector_test',
      description: 'Allow an agent to reflect TWAMP traffic',
      iconUrl: 'images/twamp-reflector.svg',
      name: 'Twamp Reflector',
      iconType: 'image',
      type: TestTypeValue.TWAMP_REFLECTOR,
      isLicenseActive: true
    }
  ];
  activeTestType: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  activeTestTypes = [];
  constructor(
    private navigationProvider: NavigationProvider,
    private licenseService: LicensesPageService,
    private readonly userService: UserService,
    private readonly templateService: TemplateService,
    private dialog: MatDialog
  ) {
    this.activeTestType = {};
  }

  ngOnInit() {
    this.templateService.setTemplateId(null);
    this.step.form = this.form;
    const selectedType = this.stateHistory(this.componentId, 'testTypesInput');
    if (selectedType && selectedType.value) {
      this.activeTestType = selectedType.value;
    }
    this.isActWebEnabled = this.licenseService.getIsActWebLicense();
    // if (!this.isActWebEnabled) {
    //   this.activeTestTypes = this.activeTestTypes.filter(item => {
    //     return item.id !== 'multistep_test';
    //   });
    // }
    this.licenseService.activeTestLicenseDetails.subscribe(data => {
      if (data?.length) {
        this.allActiveTests.forEach(item => {
          item.isLicenseActive = this.checkActiveTestLicense(item, data);
        });
      }
      this.activeTestTypes = this.allActiveTests.filter(item => item.isLicenseActive);
    });
    this.templateService.closeDialog?.subscribe(status => {
      if (status && this.templateDialogRef) {
        this.templateDialogRef.close();
      }
    });
    this.activeTestTypes = this.allActiveTests.filter(item => item.isLicenseActive);
  }

  //eslint-disable-next-line
  checkActiveTestLicense(test: any, licenseData: Array<any>): boolean {
    if (!test.licenseInfo) {
      return true;
    }
    if (licenseData?.length) {
      return licenseData.some(license => test?.licenseInfo.includes(license.featureName));
    }
  }

  // eslint-disable-next-line
  selectActiveTestType(item: any): void {
    this.activeTestType = item;
    this.typeUpdate('testTypesInput', 'testTypes', item, true);
    this.typeUpdate('testType', 'testType', item.id, true);
    if (this.step.parent?.output?.runType) {
      this.step.parent.output.runType = 'on-going';
    }
    if (
      item.id === SIDEBAR_TEST.truespeedsTest ||
      item.id === SIDEBAR_TEST.serviceTest ||
      item.id === SIDEBAR_TEST.multiStepTest ||
      item.id === SIDEBAR_TEST.voipTest ||
      item.id === SIDEBAR_TEST.networkTest ||
      item.id === SIDEBAR_TEST.twampTest ||
      item.id === SIDEBAR_TEST.twampReflectorTest ||
      item.id === SIDEBAR_TEST.y1564Test ||
      item.id === SIDEBAR_TEST.rfc2544Test ||
      item.id === SIDEBAR_TEST.y1731Test ||
      item.id === SIDEBAR_TEST.udpTest ||
      item.id === SIDEBAR_TEST.httpTest ||
      item.id === SIDEBAR_TEST.ftpTest ||
      item.id === SIDEBAR_TEST.bertTest
    ) {
      this.typeUpdate('testTypesInput', 'testTypes', item, false);
      this.wizardCtrl.toggleClose(() => {
        this.typeUpdate('testTypesInput', 'testTypes', item, true);
        this.navigateToTestSetup(item.id);
      });
    }
  }

  navigateToTestSetup(wizardId: string): void {
    this.navigationProvider.navigateToTestSetup(wizardId, { queryParamsHandling: '' });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  typeUpdate(inputVal: any, key: any, newVal: any, isValid: any) {
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: inputVal,
      key: key,
      newValue: newVal,
      isValid: isValid
    });
  }
  template(testType: string): void {
    this.templateDialogRef = this.dialog.open(TemplateTabsComponent, {
      width: '100rem',
      minHeight: '50rem',
      height: 'calc(100vh - 20px)',
      disableClose: true,
      data: {
        filterType: testType,
        myTemplatesColumnHeaders: ['name', 'accessLevel', 'lastModified', 'selectActions'],
        sharedTemplatesColumnHeaders: [
          'name',
          'accessLevel',
          'owner',
          'lastModified',
          'selectActions'
        ]
      }
    });
  }
}
